import { createSlice } from "@reduxjs/toolkit";


const cartSlice = createSlice({
    name: "Counter",
    initialState: {
        value: 0
    },
    reducers: {
        Increament: (state) => { state.value += 1 },
        Decreament: (state) => { state.value -= 1 },
        default: (state) => state.value,
    }
});

export const getCountSelector = (state) => state.count.value;


export const { Increament, Decreament } = cartSlice.actions;


export default cartSlice.reducer;